import { IconType } from '@pf/shared-common';
import { InjectionToken } from '@angular/core';

export interface INavMenu {
    displayName: string;
    hide?: boolean;
    disable?: boolean;
    callback?: (menu: INavMenu) => void;
    permissions?: string[];
}

export interface IAppMenu extends INavMenu {
    icon: keyof typeof IconType;
    route?: string;
    subMenu?: IAppSubMenu[];
    description?: string;
    category?: string;
}

export interface IAppSubMenu extends INavMenu {
    route: string;
    group?: string;
    description?: string;
}

export interface IAppRoutes {
    navigation: IAppMenu[];
}

export const AppRoutesProvider = new InjectionToken<IAppRoutes>(
    'AppRoutesProvider'
);
